import { render } from "./FieldResidenceHistory.vue?vue&type=template&id=5e38e5bb"
import script from "./FieldResidenceHistory.vue?vue&type=script&lang=js"
export * from "./FieldResidenceHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__